import React from 'react';

interface StockMovementsIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Movimientos de stock"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Una flecha curva que conecta dos puntos
 * - Flecha en forma de "L" o curva, comenzando en la esquina inferior izquierda
 * - Termina apuntando hacia la esquina superior derecha
 * - Representa flujo, transferencia o movimiento de stock
 * - Estilo minimalista, líneas limpias
 * - Simboliza el movimiento de inventario entre ubicaciones
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const StockMovementsIcon: React.FC<StockMovementsIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M120.199 3.99209C119.291 3.0838 119.291 1.58951 120.199 0.681219C121.107 -0.227073 122.601 -0.227073 123.51 0.681219L149.29 26.465C150.198 27.3733 150.198 28.8676 149.29 29.7759L123.51 55.5596C122.601 56.4679 121.107 56.4679 120.199 55.5596C119.291 54.6513 119.291 53.157 120.199 52.2488L141.966 30.4791H104.409C98.1983 30.4791 92.2221 32.9402 87.8277 37.3352L56.0715 69.0961C53.5521 71.6159 50.6225 73.6083 47.4293 74.9854C50.6225 76.3917 53.5521 78.3548 56.0715 80.8746L87.857 112.665C92.2514 117.06 98.2276 119.521 104.438 119.521H141.995L120.229 97.7512C119.32 96.8429 119.32 95.3487 120.229 94.4404C121.137 93.5321 122.631 93.5321 123.539 94.4404L149.319 120.224C150.227 121.132 150.227 122.627 149.319 123.535L123.539 149.319C122.631 150.227 121.137 150.227 120.229 149.319C119.32 148.41 119.32 146.916 120.229 146.008L141.995 124.238H104.438C96.9679 124.238 89.8198 121.279 84.5467 116.005L52.7611 84.1855C48.3668 79.7905 42.3905 77.3293 36.1799 77.3293H2.34364C1.05464 77.3293 0 76.2745 0 74.9854C0 73.6962 1.05464 72.6414 2.34364 72.6414H36.1799C42.3905 72.6414 48.3668 70.1802 52.7611 65.7852L84.5467 33.995C89.8198 28.7211 96.9679 25.7618 104.438 25.7618H141.995L120.229 3.99209H120.199Z"
        fill="currentColor"
      />
    </svg>
  );
};

